"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopUpWrap = exports.Content = exports.CloseButton = exports.DescriptionIcon = exports.Tooltip = exports.Title = exports.Head = exports.Body = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Body = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 50px;
  background-color: #fffdfc;
  box-shadow: inset 4px -4px 4px 0.5px #ffffff,
    inset -4px 4px 4px 0.5px rgb(155 117 255 / 40%);
  padding-bottom: 42px;
  width: fit-content;
    @media (max-width: 700px) {
        width: 100%;
    }
`;
exports.Head = styled_components_1.default.div `
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 64px;
  border-bottom: 1px solid #d5ceeb;
  padding: 10px 55px;
  text-align: center;
`;
exports.Title = styled_components_1.default.span `
  font-family: "GolosTextWebRegular", sans-serif;
  color: #6e77fb;
  font-size: 18px;
  line-height: 27px;
  font-weight: 500;
  text-transform: uppercase;
`;
exports.Tooltip = styled_components_1.default.div `
  position: absolute;
  font-size: 16px;
  width: 300px;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 100%);
  background: #fff;
  border: 2px dashed #6e77fb;
  border-radius: 50px;
  color: #6e77fb;
  padding: 22px;
  text-align: center;
  pointer-events: none;
  transition: all 0.5s ease;
  z-index: 2;
  box-shadow: 5px 7px 4px rgba(0, 0, 0, 0.15);
  line-height: 19px;
  visibility: hidden;
  opacity: 0;
`;
exports.DescriptionIcon = styled_components_1.default.span `
  display: inline-block;
  font-family: "GolosTextWebRegular", sans-serif;
  color: #6e77fb;
  font-weight: 500;
  text-align: center;
  text-transform: uppercase;
  border: 1px solid #6e77fb;
  border-radius: 50%;
  margin-left: 5px;
  font-size: 22px;
  line-height: 28px;
  padding: 0 8px;
  cursor: pointer;

  &:hover {
    ${exports.Tooltip} {
      visibility: visible;
      opacity: 1;
    }
  }
`;
exports.CloseButton = styled_components_1.default.button `
  position: absolute;
  width: 20px;
  height: 20px;
  cursor: pointer;
  right: 40px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;

  &:after,
  &:before {
    display: flex;
    content: "";
    width: 24px;
    height: 2px;
    background-color: #6e77fb;
    border-radius: 1px;
  }

  &:after {
    transform: rotate(45deg) translate(-1px, -2px);
  }

  &:before {
    transform: rotate(135deg);
  }
`;
exports.Content = styled_components_1.default.div `
  display: grid;
  width: 100%;
  border-bottom: 1px solid #d5ceeb;
  height: 100%;

  &.list-exercises-popup {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    border-bottom: 1px solid #d5ceeb;
    height: 100%;
    min-height: 514px;
  }
`;
exports.PopUpWrap = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  visibility: hidden;
  opacity: 0;
  z-index: -1;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  transition: all 0.8s ease;

  &,
  * {
    box-sizing: border-box;
  }

  &.open {
    z-index: 9999999;
    opacity: 1;
    visibility: visible;
  }

  &.list-exercises-popup {
    ${exports.Body} {
      max-width: 360px;
      min-height: 620px;

      width: 100%;

      @media screen and (min-width: 1000px) {
        max-width: 420px;
      }
    }

    ${exports.Content} {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-bottom: 1px solid #d5ceeb;
      height: 100%;
      min-height: 514px;
    }
  }
`;
